import SourceSelector, { normalizeSourceId, type SourceSelectorProps } from './SourceSelector';

export { normalizeSourceId };

type Props = Omit<SourceSelectorProps, 'selectionKey' | 'selected'> & {
  selected: Set<string>;
};

/** Backward-compatible wrapper — prefer SourceSelector with selectionKey="id". */
export default function SourceAssignmentPicker(props: Props) {
  return <SourceSelector {...props} selectionKey="id" />;
}
